import { LitElement, html, svg } from 'lit';

export class IconRoomService32 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><title>Hanskekledd hånd og serveringsbrett med kuppel</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M1 19.005v12M1 21.005h7a4 4 0 0 1 4 4h5a4 4 0 0 1 4 4H1M8 25.005h4M3 15.005h28M17 1.005v2M29 15.005a12 12 0 0 0-24 0h24ZM15 19.005h9.533a4 4 0 0 0 3.572-2.205l.796-1.596"></path></svg>`; }
}
if (!customElements.get('f-icon-room-service32', IconRoomService32)) {
  customElements.define('f-icon-room-service32', IconRoomService32);
}